/**
 * Validates a template name to ensure it doesn't contain characters
 * that could break URL routing (like /, \, ?, #, etc.)
 * 
 * @param {string} name - The template name to validate
 * @returns {{isValid: boolean, error: string|null}} - Validation result with error message if invalid
 */
export const validateTemplateName = (name) => {
  if (!name || typeof name !== 'string') {
    return { isValid: false, error: 'Template name is required' };
  }

  const trimmedName = name.trim();
  if (!trimmedName) {
    return { isValid: false, error: 'Template name cannot be empty' };
  }

  // Characters that break URLs: /, \, ?, #, &, =, +, %
  const invalidChars = /[/\\?#&=+%]/;
  
  if (invalidChars.test(trimmedName)) {
    const foundChars = trimmedName.match(/[/\\?#&=+%]/g);
    const uniqueChars = [...new Set(foundChars)];
    return {
      isValid: false,
      error: `Template name contains unsupported characters: ${uniqueChars.join(', ')}. These characters are not allowed: /, \\, ?, #, &, =, +, %`
    };
  }

  return { isValid: true, error: null };
};
